import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import {
  type AutomationsAnalyticsPromptMode,
  type AutomationsAnalyticsScheduleRepeat,
  withAutomationsCategory,
} from './automationsAnalytics';
import META from './useTrackAutomationSaved.meta';

export type UseTrackAutomationSavedParams = {
  automation_id: string;
  prompt_mode: AutomationsAnalyticsPromptMode;
  schedule_repeat?: AutomationsAnalyticsScheduleRepeat;
};

export const useTrackAutomationSaved = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationSaved = useCallback(
    (params: UseTrackAutomationSavedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationSaved };
};
